import FacebookBadge from '../../../images/custom/badges/FacebookBadge.svg';
import FacebookDisabled from '../../../images/custom/badges/FacebookDisabled.svg';

import GoogleBadge from '../../../images/custom/badges/GoogleBadge.svg';
import GoogleDisabled from '../../../images/custom/badges/GoogleDisabled.svg';

import ReviewpushBadge from '../../../images/custom/badges/ReviewpushBadge.svg';
import ReviewpushDisabled from '../../../images/custom/badges/ReviewpushDisabled.svg';

import YelpBadge from '../../../images/custom/badges/YelpBadge.svg';
import YelpDisabled from '../../../images/custom/badges/YelpDisabled.svg';

import TripAdvisorBadge from '../../../images/custom/badges/TripAdvisorBadge.svg';
import TripAdvisorDisabled from '../../../images/custom/badges/TripAdvisorDisabled.svg';

import DefaultBadge from '../../../images/custom/badges/DefaultBadge.svg';
import DefaultDisabledBadge from '../../../images/custom/badges/DefaultDisabledBadge.svg';

export default {
    props: {
        name: {
            type: String,
            require: true,
        },
        disabled: {
            type: Boolean,
            require: false,
        },
    },
    components: {
        FacebookBadge,
        FacebookDisabled,
        GoogleBadge,
        GoogleDisabled,
        ReviewpushBadge,
        ReviewpushDisabled,
        TripAdvisorBadge,
        TripAdvisorDisabled,
        YelpBadge,
        YelpDisabled,
        DefaultBadge,
        DefaultDisabledBadge
    },
    name: 'RPSiteBadge',
    computed: {
        activeComponent(){
            switch(this.name.toLowerCase()){
            case 'facebook':
                return 'FacebookBadge';
            case 'google':
                return 'GoogleBadge';
            case 'reviewpush':
                return 'ReviewpushBadge';
            case 'yelp':
                return 'YelpBadge';
            case 'tripadvisor':
                return 'TripAdvisorBadge';
            default:
                return 'DefaultBadge';
            }
        },
        disabledComponent(){
            switch(this.name.toLowerCase()){
            case 'facebook':
                return 'FacebookDisabled';
            case 'google':
                return 'GoogleDisabled';
            case 'reviewpush':
                return 'ReviewpushDisabled';
            case 'yelp':
                return 'YelpDisabled';
            case 'tripadvisor':
                return 'TripAdvisorDisabled';
            default:
                return 'DefaultDisabledBadge';
            }
        }
    },
    render(h){
        if(this.disabled) {
            return h(this.disabledComponent);
        }
        return h(this.activeComponent);
    },
};
